export default __webpack_public_path__ + "static/media/BSHARE.5bf393c1.svg";